module.exports = {
      id: "calendar-usage",
      viewBox: "0 0 17.552 17.301",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#calendar",
      toString: function () {
        return this.url;
      }
    }